import type { OnlineServiceFeeLine } from '@order-up/models';

/**
 * The server-resolved Online Service Fee line from a public payload, or null
 * for anything that is not exactly one. A guest is shown a fee only when the
 * SERVER said one applies (spec 2026-10-05 §2, deviation g). Only the three
 * line fields are kept — nothing else from the payload rides along.
 */
export function readOnlineServiceFeeLine(raw: unknown): OnlineServiceFeeLine | null {
  if (!raw || typeof raw !== 'object') return null;
  const { amount, tax, label } = raw as Record<string, unknown>;
  return typeof amount === 'number' &&
    Number.isFinite(amount) &&
    amount > 0 &&
    typeof tax === 'number' &&
    Number.isFinite(tax) &&
    tax >= 0 &&
    typeof label === 'string' &&
    label.length > 0
    ? { amount, tax, label }
    : null;
}
